import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Autoplay, Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {Banner as BannerType} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

interface CategoryBannerSwiperProps {
    readonly categoryId: number;
    readonly categoryBanners?: BannerType[];
}
const CategoryBannerMobile = ({categoryBanners}: CategoryBannerSwiperProps) => {
    if (!categoryBanners || categoryBanners?.length === 0) {
        return <></>;
    }
    return (
        <div className="w-full bg-white py-4">
            <Swiper
                modules={[Autoplay]}
                slidesPerView={1.1}
                centeredSlides
                initialSlide={1}
                spaceBetween={-10}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                loop={true}>
                {categoryBanners.map((banner, index) => (
                    <>
                        {banner?.image_mobile && (
                            <SwiperSlide key={banner?.banner_id}>
                                {({isActive}) => (
                                    <Link href={`${banner?.url_banner}`}>
                                        <div className="h-full">
                                            <Image
                                                className={`w-full rounded-md transition-all ${isActive ? 'scale-100' : 'scale-90'}`}
                                                src={getBannerUrlByPath(banner?.image_mobile!)}
                                                alt={banner?.name ?? 'Category Banner'}
                                                width={index > 0 ? 330 : 331}
                                                height={index > 0 ? 140 : 141}
                                                priority={index === 0}
                                                loading={index === 0 ? 'eager' : 'lazy'}
                                                fetchPriority={index === 0 ? 'high' : 'auto'}
                                                sizes="330px"
                                            />
                                        </div>
                                    </Link>
                                )}
                            </SwiperSlide>
                        )}
                    </>
                ))}
            </Swiper>
        </div>
    );
};

export default CategoryBannerMobile;
